import { arrayOf, bool, exact, number, shape, string } from "prop-types";
import { baseDatabaseModelType } from "./baseDatabaseModel";
import { translationType } from "./translationType";

/** @deprecated use TypeScript interface or type instead */
export const formFieldPropertyType = shape({
  ...baseDatabaseModelType,
  min: number,
  max: number,
  url: string,
  allowedFileTypes: arrayOf(string),
  id: string.isRequired,
  partitionKey: string.isRequired,
  _t: string.isRequired,
  categoryId: string.isRequired,
  maintainedBy: string,
  target: string,
  name: string.isRequired,
  dependsOnPropertyId: string,
  dependsOnPropertyValues: arrayOf(string),
  label: translationType.isRequired,
  placeholder: translationType,
  property: exact({
    status: string,
  }),
  requiredValidationText: translationType,
  fieldType: string.isRequired,
  order: number.isRequired,
  requiredForStatuses: arrayOf(string),
  editableByStatus: string,
  trackHistory: bool,
  status: string.isRequired,
  isDeleted: bool.isRequired,
  formType: string,
  startDateValidationField: string,
  maxCharacterLength: number,
  businessUnitIds: arrayOf(string),
  precision: number,
  lockOnSubmission: bool,
  includeTime: bool,
  timeParentField: string,
});
